<script lang="ts">
  import '../../app.css';
  import { currentRoute } from '../stores/router';
  import ThemePicker from './ThemePicker.svelte';
  import DebugToggle from './DebugToggle.svelte';
  import LandingPage from './landing/LandingPage.svelte';
  import DebuggerPage from './DebuggerPage.svelte';
  import S3ExplorerPage from './s3-explorer/S3ExplorerPage.svelte';
  import DdbViewerPage from './ddb-viewer/DdbViewerPage.svelte';
  import LogExplorerPage from './log-explorer/LogExplorerPage.svelte';
  import SqsMonitorPage from './sqs-monitor/SqsMonitorPage.svelte';
  import LambdaInspectorPage from './lambda-inspector/LambdaInspectorPage.svelte';
  import HealthDashboardPage from './health-dashboard/HealthDashboardPage.svelte';
  import StrategyLifecyclePage from './strategy-lifecycle/StrategyLifecyclePage.svelte';
</script>

<ThemePicker />
<DebugToggle />
{#if $currentRoute === 'landing'}
  <LandingPage />
{:else if $currentRoute === 'debugger'}
  <DebuggerPage />
{:else if $currentRoute === 's3-explorer'}
  <S3ExplorerPage />
{:else if $currentRoute === 'ddb-viewer'}
  <DdbViewerPage />
{:else if $currentRoute === 'log-explorer'}
  <LogExplorerPage />
{:else if $currentRoute === 'sqs-monitor'}
  <SqsMonitorPage />
{:else if $currentRoute === 'lambda-inspector'}
  <LambdaInspectorPage />
{:else if $currentRoute === 'health-dashboard'}
  <HealthDashboardPage />
{:else if $currentRoute === 'strategy-lifecycle'}
  <StrategyLifecyclePage />
{:else}
  <!-- Placeholder for tools not yet built -->
  <div class="min-h-screen bg-bg-dark text-text-primary font-sans flex items-center justify-center">
    <div class="text-center">
      <p class="text-4xl mb-4">🚧</p>
      <h2 class="text-xl font-semibold mb-2">Coming Soon</h2>
      <p class="text-text-secondary mb-4">This tool is under construction</p>
      <button onclick={() => window.location.hash = '#/'} class="text-accent hover:underline">← Back to Home</button>
    </div>
  </div>
{/if}
